import "./forgetPass.scss";
import { useState } from "react";
import { sendPasswordResetEmail, getAuth } from "firebase/auth";
import { useAlert } from "react-alert";
import comittyLogo from "../../components/logos/logo.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import backButton from "../../images/icons/back.png";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import Aurora from "../../components/aurora/Aurora.jsx";

export const ForgetPass = () => {
  const { t } = useTranslation("login");
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const alert = useAlert();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const isValidEmail = (email) => {
    let regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]+)*$/;
    return regexEmail.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail(formData.email)) {
      return alert.show(t("invalid_email"));
    }
    const auth = getAuth();
    await sendPasswordResetEmail(auth, formData.email)
      .then(() => {
        alert.show(t("verification_sent"));
        setFormData({});
        navigate("/login");
      })
      .catch((error) => {
        alert.show(t("error_occured"));
      });
  };

  return (
    <div className="forgetPassword">
      <Aurora />

      <div className="forgetPasswordInner">
        <div className="commityImg">
          <img className="img-fluid" src={comittyLogo} alt="" />
        </div>
        <div className="forgetPasswordForm">
          <div className="titleContainer">
            <button className="buttonBackContainer" onClick={() => navigate("/login")}>
              <img src={backButton} alt="Back" />
              <p>{t("return")}</p>
            </button>
            <h3>{t("reset_password")}</h3>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="fieldGroup">
              <label>Email</label>
              <input
                name="email"
                value={formData.email}
                onChange={(e) => handleChange(e)}
                required
                className="form-control"
                type="text"
              />
            </div>
            <button className="forgetPasswordBtn" type="submit">
              {t("submit")}
            </button>
          </form>
          <div className="languageSwitcherContainer">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </div>
  );
};
